import { onBeforeUnmount, ref, shallowRef, watch } from 'vue';
import { requestApi } from '@/api';

export const dashboardHistoryKey = Symbol('dashboardHistory');

// One request shared by the headline cards and the expandable history table.
export function useDashboardHistory(cityId) {
  const history = shallowRef(null);
  const loading = ref(false);
  const error = ref(null);
  let controller;
  let generation = 0;
  let pending;

  function reset() {
    ++generation;
    controller?.abort();
    pending = null;
    history.value = null;
    error.value = null;
    loading.value = false;
  }
  function load(force = false) {
    if (!force && pending) return pending;
    if (!force && history.value) return Promise.resolve();
    reset();
    const current = generation;
    controller = new AbortController();
    loading.value = true;
    pending = (async () => {
      try {
        const result = await requestApi(`/v1/cities/${encodeURIComponent(cityId.value)}/dashboard/history`, { requireAuth: true, signal: controller.signal });
        if (current !== generation) return;
        if (result?.cityId !== cityId.value || !Array.isArray(result.rows) || !Array.isArray(result.unavailableDates)) throw new Error('Invalid history');
        history.value = result;
      } catch {
        if (current === generation) error.value = 'Snapshot history could not be loaded.';
      } finally {
        if (current === generation) { loading.value = false; pending = null; }
      }
    })();
    return pending;
  }
  watch(cityId, reset, { flush: 'sync' });
  onBeforeUnmount(reset);
  return { history, loading, error, load };
}
